import React from "react";
import SkillsComparison from "./SkillsComparison";
import {Element} from "react-scroll";

interface SkillsComparisonProps {
    hightSkills?: group[];
    templateAnswerResult?: string
    activeTemplate?: boolean
    feedbackAssisstant: Map<string, string>
}

interface group {
    groupTitle: string,
    totalPoint: number,
    totalQuestion: number,
    advice: string,
    avgPoint: number,
    stdevpPoint: number,
    deviation: number,
    exposition: string,
    isLowSkill?: string,
    acronym?: string
}
const HighSkill: React.FC<{ data: SkillsComparisonProps, content?: Record<string, (string|boolean)[]>, defaultTemplate?: boolean }> = ({ data, content, defaultTemplate }) => {
    return (
        <Element name="highSkills">
            <div className={"div-section"} style={{marginTop: '48px'}}>
                <div style={{height: '40px'}}>
                    <span className="title-section">
                        {  content?.TITLE?.[0] ? typeof content?.TITLE?.[0] != 'boolean' ? content?.TITLE?.[0] : <>差値が<span style={{color: '#17AE8C'}}>高かった</span>スキル</> : <>差値が<span style={{color: '#17AE8C'}}>高かった</span>スキル</>}
                    </span>
                </div>

                <div className={"border-title"}>
                    <div className={"underline-title-high-low-skill"}></div>
                </div>
                {
                    data.hightSkills &&
                    <SkillsComparison data={data.hightSkills} feedback={(content?.FEEDBACK?.[0] || defaultTemplate) ? data.feedbackAssisstant.get('1') != null ? data.feedbackAssisstant.get('1') : '' : ''} text={(content?.TEXT?.[0] || defaultTemplate) ? typeof content?.TEXT?.[0] === "string" ? content?.TEXT?.[0] : '' : ''}/>
                }
            </div>
        </Element>
    );
};

export default HighSkill;
